// @flow

import React, { Component, type Node } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, type FormProps } from 'redux-form';
import { injectIntl, type IntlShape } from 'react-intl';

import type { Dispatch, NamespaceDefinition } from 'state/types';
import DialogPanel from 'view/App/DialogPanels/DialogPanel';
import { hideDialogPanel } from 'state/commands/dialogPanelCommands';
import localizedStrings from 'util/localizedStrings';
import { CREATE_XMP_NAMESPACE_PANEL_ID } from 'util/constants';
import { bindActionCreatorsForm } from 'util/safeDispatch';
import { getActivePanelId, getCustomXMPNamespaces } from 'state/selectors';
import FormField from 'view/Forms/FormField';
import { addCustomXmpNamespaces } from 'state/commands/catalogCommands';

type Props = {
  addCustomXmpNamespaces: typeof addCustomXmpNamespaces,
  customXmpNamespaces: NamespaceDefinition[],
  hideDialogPanel: typeof hideDialogPanel,
  intl: IntlShape,
  onAddCustomXmpNamespace: NamespaceDefinition => void,
} & FormProps;

function renderInput({
  id,
  input,
  type,
  meta: { touched, error, warning },
}): Node {
  const hasError = error && touched;
  return (
    <input
      {...input}
      id={id}
      className={`input ${hasError ? 'is-danger' : ''}`}
      type={type}
    />
  );
}

class CreateXMPNamespaceDialog extends Component<Props> {
  isOkEnabled: Function;
  submit: Function;

  constructor() {
    super();

    this.isOkEnabled = this.isOkEnabled.bind(this);
    this.submit = this.submit.bind(this);
  }

  isOkEnabled() {
    return this.props.valid;
  }

  submit(data: Object, props: Props) {
    this.props.addCustomXmpNamespaces([
      { id: 0, namespace: data.uri, preferredAbbreviation: data.abbreviation },
    ]);
  }

  render() {
    const {
      activePanelId,
      handleSubmit,
      intl: { formatMessage },
    } = this.props;
    return (
      <DialogPanel
        activePanelId={activePanelId}
        contentStyle={{ width: '600px', height: null }}
        dialogFocusId="abbreviation"
        hideDialogPanel={this.props.hideDialogPanel}
        isOkEnabled={this.isOkEnabled}
        onSave={handleSubmit(this.submit)}
        panelId={CREATE_XMP_NAMESPACE_PANEL_ID}
        panelTitle={formatMessage(localizedStrings.FIELD_NEW_NAMESPACE_TITLE)}
        showCancel
        customButtonText={formatMessage(localizedStrings.SUBMIT)}
      >
        <form className="portfolio-form-container">
          <FormField
            label={formatMessage(localizedStrings.FIELD_NAMESPACE_ABBREVIATION)}
          >
            <Field
              id="abbreviation"
              name="abbreviation"
              component={renderInput}
              type="text"
            />
          </FormField>
          <FormField
            label={formatMessage(localizedStrings.FIELD_NAMESPACE_URI)}
          >
            <Field name="uri" component={renderInput} type="text" />
          </FormField>
        </form>
      </DialogPanel>
    );
  }
}

function validate(data: Object, props: Props) {
  const errors = {};
  if (!data.abbreviation) {
    errors.abbreviation = 'Required';
  } else if (
    props.customXmpNamespaces.find(
      ns => ns.preferredAbbreviation === data.abbreviation
    )
  ) {
    errors.abbreviation = 'Duplicate';
  }

  if (!data.uri) {
    errors.uri = 'Required';
  } else if (props.customXmpNamespaces.find(ns => ns.namespace === data.uri)) {
    errors.uri = 'Duplicate';
  }

  return errors;
}

const form = reduxForm({ form: CREATE_XMP_NAMESPACE_PANEL_ID, validate })(
  CreateXMPNamespaceDialog
);

export default connect(
  state => ({
    activePanelId: getActivePanelId(state),
    customXmpNamespaces: getCustomXMPNamespaces(state),
  }),
  (dispatch: Dispatch) =>
    bindActionCreatorsForm({ addCustomXmpNamespaces, hideDialogPanel })
)(injectIntl(form));



// WEBPACK FOOTER //
// ./src/view/Pages/CatalogsPage/CreateXMPNamespaceDialog.js